/* Xeuphoria · the shop · behaviour (15 Oct 2026)
   Shared by the homepage (sections/xeu-home-v2.liquid) and the piano books page (sections/xeu-book.liquid).
     1 · the free downloads: one email opens every free thing (unchanged from 8 Oct)
     2 · the basket: Shopify's own cart, in a panel on the page
     3 · listen: thirty seconds of each piece, one at a time
     4 · the viewer: every picture full size, look inside the books, tap to zoom, swipe or arrow through
     5 · light: the girls sit in their own light, the covers catch it, the windows come on as you arrive
   Words come from <script data-xeu-words>, pictures and previews from <script data-xeu-showcase>.
   Reduced motion: part 5 never runs and nothing moves on its own. */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  var root = doc.querySelector('[data-xeu-root]');
  if (!root) return;
  window.XeuShop = { v: '2026-10-15b' };
  html.classList.add('xeu-js');
  // the words wait for their typefaces under a line at the top of each section; without that line, they don't wait
  if (!window.XeuGate) html.classList.add('xeu-type');

  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && matchMedia('(pointer: fine)').matches;
  function $(s, el) { return (el || doc).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); }
  function readJSON(sel) { var n = $(sel); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var W = readJSON('[data-xeu-words]') || {};
  var SETS = readJSON('[data-xeu-showcase]') || {};
  var TRACKS = SETS.listen || [];

  function store(kind, k, v) { try { window[kind].setItem(k, v); } catch (e) {} }
  function read(kind, k) { try { return window[kind].getItem(k); } catch (e) { return null; } }
  function drop(kind, k) { try { window[kind].removeItem(k); } catch (e) {} }

  /* ── 1 · the free downloads ──────────────────────────────────────────────── */
  var KEY = 'xeu_unlocked', INTENT = 'xeu_intent';
  var dialog = $('[data-xeu-dialog]', root);
  var dTitle = $('[data-xeu-dialog-title]', root);
  var dTags = $('[data-xeu-tags]', root);
  var toast = $('[data-xeu-toast]', root);
  function unlock() { root.classList.add('is-unlocked'); store('localStorage', KEY, '1'); }
  function say(text) {
    if (!toast || !text) return;
    toast.textContent = text; toast.hidden = false;
    setTimeout(function () { toast.hidden = true; }, 7000);
  }
  function openFor(slug, title) {
    if (!dialog) return;
    if (dTitle) dTitle.textContent = title || W.skies || '';
    if (dTags) dTags.value = 'letter, free-download, ' + slug;
    store('sessionStorage', INTENT, 'pack:' + slug);
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    var inp = dialog.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus(); }, 50);
  }
  if (read('localStorage', KEY) === '1') root.classList.add('is-unlocked');

  /* ── 2 · the basket ──────────────────────────────────────────────────────── */
  var basket = $('[data-xeu-basket]', root);
  var veil = $('.xeu-basket-veil', root);
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(cents, cur) {
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function small(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : url; }
  function setCount(n) {
    $$('[data-xeu-count]', root).forEach(function (c) { c.textContent = n; });
    $$('[data-xeu-basket-open]', root).forEach(function (a) { a.hidden = n < 1; });
  }
  function renderCart(c) {
    if (!basket) return;
    var list = $('[data-xeu-basket-items]', basket);
    list.innerHTML = '';
    (c.items || []).forEach(function (it) {
      var li = doc.createElement('li'); li.className = 'xeu-basket-item';
      if (it.image) { var im = doc.createElement('img'); im.src = small(it.image); im.alt = ''; im.width = 64; li.appendChild(im); }
      var copy = doc.createElement('div'); copy.className = 'xeu-basket-item-copy';
      var t = doc.createElement('p'); t.className = 'xeu-basket-item-title'; t.textContent = it.product_title; copy.appendChild(t);
      var pr = doc.createElement('div'); pr.className = 'xeu-basket-item-price';
      pr.textContent = (it.quantity > 1 ? it.quantity + ' × ' : '') + money(it.final_line_price, c.currency); copy.appendChild(pr);
      var rm = doc.createElement('button'); rm.type = 'button'; rm.className = 'xeu-basket-remove'; rm.textContent = W.remove || 'Remove';
      rm.addEventListener('click', function () { change(it.key, 0); }); copy.appendChild(rm);
      li.appendChild(copy); list.appendChild(li);
    });
    var empty = !(c.items && c.items.length);
    $('[data-xeu-basket-empty]', basket).hidden = !empty;
    $('[data-xeu-basket-foot]', basket).hidden = empty;
    $('[data-xeu-basket-total]', basket).textContent = money(c.total_price || 0, c.currency);
    setCount(c.item_count || 0);
  }
  function loadCart() {
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function change(key, qty) {
    return fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function openBasket() {
    if (!basket) return;
    basket.hidden = false; if (veil) veil.hidden = false;
    requestAnimationFrame(function () { basket.classList.add('is-open'); if (veil) veil.classList.add('is-open'); });
    loadCart();
    var x = $('.xeu-dialog-close', basket); if (x) setTimeout(function () { x.focus(); }, 60);
  }
  function closeBasket() {
    if (!basket || basket.hidden) return;
    basket.classList.remove('is-open'); if (veil) veil.classList.remove('is-open');
    setTimeout(function () { basket.hidden = true; if (veil) veil.hidden = true; }, 450);
  }
  $$('[data-xeu-basket-open]', root).forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openBasket(); });
  });
  $$('[data-xeu-basket-close]', root).forEach(function (b) { b.addEventListener('click', closeBasket); });
  $$('[data-xeu-add-form]', root).forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button'); if (btn) btn.disabled = true;
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(f.elements.id.value), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { openBasket(); })
        .catch(function () { f.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  $$('[data-xeu-get]', root).forEach(function (b) {
    b.addEventListener('click', function () { openFor(b.getAttribute('data-xeu-get'), b.getAttribute('data-title')); });
  });
  $$('[data-xeu-close]', root).forEach(function (b) {
    b.addEventListener('click', function () { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); });
  });
  $$('form[data-intent]', root).forEach(function (f) {
    f.addEventListener('submit', function () {
      var i = f.getAttribute('data-intent');
      if (i !== 'pack') store('sessionStorage', INTENT, i);
    });
  });
  (function posted() {
    var was = /[?&]customer_posted=true/.test(location.search) || !!$('[data-xeu-posted]', root);
    var intent = read('sessionStorage', INTENT) || '';
    if (was) {
      unlock();
      drop('sessionStorage', INTENT);
      if (intent.indexOf('pack:') === 0) {
        var card = doc.getElementById('pack-' + intent.slice(5));
        if (card) { card.classList.add('is-new'); setTimeout(function () { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300); }
        say(W.toastPack);
      } else if (intent === 'books') {
        say(W.toastBooks);
      } else {
        say(W.toastLetter);
      }
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.hash);
    } else {
      var err = $('[data-xeu-pack-err]', root);
      if (err && intent.indexOf('pack:') === 0) {
        var b = $('[data-xeu-get="' + intent.slice(5) + '"]', root);
        openFor(intent.slice(5), b ? b.getAttribute('data-title') : '');
      }
      $$('.xeu-form-err', root).forEach(function (e) {
        var f = e.closest('form');
        var mine = f && ((f.getAttribute('data-intent') === 'books' && intent === 'books') || (f.getAttribute('data-intent') === 'letter' && intent === 'letter') || (f.getAttribute('data-intent') === 'pack' && intent.indexOf('pack:') === 0));
        if (!mine) e.hidden = true;
      });
    }
  })();

  /* ── 3 · listen ──────────────────────────────────────────────────────────── */
  var Player = (function () {
    var byId = {}; TRACKS.forEach(function (t) { byId[t.id] = t; });
    var audio = null, cur = null, raf = 0;
    function el() {
      if (audio) return audio;
      audio = new Audio(); audio.preload = 'none';
      ['play', 'playing', 'pause', 'ended', 'error', 'waiting'].forEach(function (ev) { audio.addEventListener(ev, sync); });
      return audio;
    }
    function playing() { return !!(audio && !audio.paused && !audio.ended); }
    function toggle(id) {
      if (!byId[id]) return;
      var a = el();
      if (cur === id && playing()) { a.pause(); return; }
      if (cur !== id) { if (cur) setP(cur, 0); cur = id; a.src = byId[id].src; }
      else if (a.ended) { a.currentTime = 0; }
      var p = a.play(); if (p && p.catch) p.catch(function () { sync(); });
      sync();
    }
    function stop() { if (audio && !audio.paused) audio.pause(); }
    function setP(id, p) { $$('[data-xeu-track="' + id + '"]').forEach(function (r) { r.style.setProperty('--p', p.toFixed(4)); }); }
    function tick() {
      raf = 0;
      if (!playing()) return;
      setP(cur, clamp(audio.currentTime / (audio.duration || 30), 0, 1));
      raf = requestAnimationFrame(tick);
    }
    function sync() {
      var on = playing();
      $$('[data-xeu-track]').forEach(function (row) {
        var id = row.getAttribute('data-xeu-track'), mine = id === cur;
        row.classList.toggle('is-current', mine);
        row.classList.toggle('is-playing', mine && on);
        var b = row.querySelector('[data-xeu-play]');
        if (b && byId[id]) b.setAttribute('aria-label', ((mine && on) ? (W.pause || 'Pause') : (W.play || 'Play')) + ' · ' + byId[id].title);
      });
      root.classList.toggle('is-listening', on);
      if (audio && audio.ended && cur) setP(cur, 0);
      if (on && !raf) raf = requestAnimationFrame(tick);
    }
    function bind(scope) {
      $$('[data-xeu-track]', scope).forEach(function (row) {
        if (row.__xeuBound) return; row.__xeuBound = true;
        row.addEventListener('click', function (e) {
          if (e.target.closest('[data-xeu-open]')) return;
          toggle(row.getAttribute('data-xeu-track'));
        });
      });
    }
    bind(root);
    return { toggle: toggle, stop: stop, sync: sync, bind: bind, track: function (id) { return byId[id]; } };
  })();

  /* ── 4 · the viewer ──────────────────────────────────────────────────────── */
  var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var ICON_X = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
  var PLAYER_ICONS = '<span class="xeu-track-play" aria-hidden="true"><svg class="xeu-ring" viewBox="0 0 40 40"><circle class="xeu-ring-bg" cx="20" cy="20" r="18"/><circle class="xeu-ring-fg" cx="20" cy="20" r="18"/></svg>' +
    '<svg class="xeu-ico xeu-ico-play" viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z"/></svg><svg class="xeu-ico xeu-ico-pause" viewBox="0 0 24 24"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg></span>';

  var Viewer = (function () {
    var v, stage, img, cap, count, title, rail, hint, listenBtn, listenText, prevB, nextB, xB;
    var items = [], setName = '', i = 0, opener = null, open = false, swapT = 0;
    var Z = { on: false, s: 1, x: 0, y: 0, mx: 0, my: 0 };
    var drag = null;

    function build() {
      if (v) return;
      v = doc.createElement('div');
      v.className = 'xeu-viewer'; v.hidden = true;
      v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true');
      v.innerHTML =
        '<div class="xeu-viewer-top"><div class="xeu-code xeu-code--bone" data-v-title></div><div class="xeu-viewer-count" data-v-count aria-live="polite"></div>' +
        '<button type="button" class="xeu-dialog-close xeu-viewer-x" data-v-x>' + ICON_X + '</button></div>' +
        '<div class="xeu-viewer-stage" data-v-stage><img class="xeu-viewer-img" data-v-img alt="" decoding="async" draggable="false">' +
        '<button type="button" class="xeu-viewer-nav xeu-viewer-nav--prev" data-v-prev>' + ICON_PREV + '</button>' +
        '<button type="button" class="xeu-viewer-nav xeu-viewer-nav--next" data-v-next>' + ICON_NEXT + '</button></div>' +
        '<div class="xeu-viewer-foot"><p class="xeu-viewer-cap" data-v-cap></p>' +
        '<button type="button" class="xeu-viewer-listen" data-v-listen hidden>' + PLAYER_ICONS + '<span data-v-listen-text></span></button>' +
        '<div class="xeu-viewer-hint" data-v-hint></div></div>' +
        '<div class="xeu-viewer-rail" data-v-rail></div>';
      root.appendChild(v);
      stage = $('[data-v-stage]', v); img = $('[data-v-img]', v); cap = $('[data-v-cap]', v); count = $('[data-v-count]', v);
      title = $('[data-v-title]', v); rail = $('[data-v-rail]', v); hint = $('[data-v-hint]', v);
      listenBtn = $('[data-v-listen]', v); listenText = $('[data-v-listen-text]', v);
      prevB = $('[data-v-prev]', v); nextB = $('[data-v-next]', v); xB = $('[data-v-x]', v);
      xB.setAttribute('aria-label', W.close || 'Close');
      prevB.setAttribute('aria-label', W.prev || 'Previous');
      nextB.setAttribute('aria-label', W.next || 'Next');
      xB.addEventListener('click', close);
      prevB.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      nextB.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
      listenBtn.addEventListener('click', function () { var id = listenBtn.getAttribute('data-xeu-track'); if (id) Player.toggle(id); });
      stage.addEventListener('pointerdown', down);
      stage.addEventListener('pointermove', move);
      stage.addEventListener('pointerup', up);
      stage.addEventListener('pointercancel', function () { drag = null; stage.classList.remove('is-dragging'); img.style.transition = ''; if (!Z.on) img.style.transform = ''; });
      doc.addEventListener('keydown', function (e) { if (open) trap(e); }, true);
      addEventListener('resize', function () { if (open && Z.on) clampZ(true); });
    }

    function openSet(name, index, from) {
      var list = SETS[name];
      if (!list || !list.length) return;
      build();
      items = list; setName = name; opener = from || doc.activeElement;
      title.textContent = (W.titles && W.titles[name]) || (name.indexOf('sky-') === 0 ? (W.titles && W.titles.sky) || '' : '');
      hint.textContent = W.hint || '';
      rail.innerHTML = '';
      items.forEach(function (it, n) {
        var b = doc.createElement('button'); b.type = 'button';
        b.className = 'xeu-viewer-thumb' + (it.w > it.h * 1.3 ? ' xeu-viewer-thumb--wide' : '');
        b.setAttribute('aria-label', (n + 1) + ' / ' + items.length);
        var t = doc.createElement('img'); t.src = it.thumb || it.src; t.alt = ''; t.loading = 'lazy';
        b.appendChild(t);
        b.addEventListener('click', function () { show(n, n > i ? 1 : -1); });
        rail.appendChild(b);
      });
      rail.hidden = items.length < 2;
      prevB.hidden = nextB.hidden = items.length < 2;
      v.hidden = false; open = true;
      html.classList.add('xeu-lock');
      requestAnimationFrame(function () { v.classList.add('is-open'); });
      show(clamp(index || 0, 0, items.length - 1), 0, true);
      setTimeout(function () { xB.focus(); }, 60);
    }

    function close() {
      if (!open) return;
      open = false; unzoom(true);
      v.classList.remove('is-open');
      html.classList.remove('xeu-lock');
      setTimeout(function () { if (!open) { v.hidden = true; img.removeAttribute('src'); } }, 400);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    function load(it) {
      // show the small picture straight away, then the full one when it arrives
      img.classList.toggle('is-page', !!it.page);
      img.alt = it.alt || '';
      img.src = it.thumb || it.src;
      if (it.src && it.src !== it.thumb) {
        var full = new Image(); full.decoding = 'async';
        full.onload = function () { if (items[i] === it) img.src = it.src; };
        full.src = it.src;
      }
      [i - 1, i + 1].forEach(function (n) { var nb = items[n]; if (nb && nb.src) { var p = new Image(); p.src = nb.src; } });
    }

    function show(n, dir, first) {
      if (n < 0 || n >= items.length) return;
      unzoom(true);
      var it = items[n]; i = n;
      count.textContent = items.length > 1 ? (n + 1) + ' / ' + items.length : '';
      cap.textContent = it.cap || '';
      prevB.disabled = n === 0; nextB.disabled = n === items.length - 1;
      $$('.xeu-viewer-thumb', rail).forEach(function (b, k) { b.classList.toggle('is-current', k === n); if (k === n && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' }); });
      if (it.listen && Player.track(it.listen)) {
        listenBtn.hidden = false;
        listenBtn.setAttribute('data-xeu-track', it.listen);
        listenText.textContent = (W.listen || 'Listen') + ' · ' + Player.track(it.listen).title;
        Player.sync();
      } else {
        listenBtn.hidden = true; listenBtn.removeAttribute('data-xeu-track');
      }
      clearTimeout(swapT);
      if (first || REDUCED) { load(it); img.classList.remove('is-out'); img.style.transform = ''; return; }
      img.classList.add('is-out');
      img.style.transform = 'translate3d(calc(-50% + ' + (-dir * 26) + 'px), -50%, 0)';
      swapT = setTimeout(function () {
        load(it);
        img.style.transition = 'none';
        img.style.transform = 'translate3d(calc(-50% + ' + (dir * 26) + 'px), -50%, 0)';
        void img.offsetWidth;
        img.style.transition = '';
        img.classList.remove('is-out');
        img.style.transform = '';
      }, 200);
    }

    function go(d) { if (Z.on) unzoom(); show(i + d, d); }

    /* zoom: tap or click the picture; drag (or move the mouse) to look around; tap again to let go */
    function apply() {
      img.style.transform = Z.on ? 'translate3d(calc(-50% + ' + Z.x.toFixed(1) + 'px), calc(-50% + ' + Z.y.toFixed(1) + 'px), 0) scale(' + Z.s.toFixed(3) + ')' : '';
    }
    function clampZ(doApply) {
      var r = stage.getBoundingClientRect();
      var w = img.offsetWidth * Z.s, h = img.offsetHeight * Z.s;
      Z.mx = Math.max(0, (w - r.width) / 2 + 20); Z.my = Math.max(0, (h - r.height) / 2 + 20);
      Z.x = clamp(Z.x, -Z.mx, Z.mx); Z.y = clamp(Z.y, -Z.my, Z.my);
      if (doApply) apply();
    }
    function zoomAt(cx, cy) {
      var r = img.getBoundingClientRect();
      var natural = img.naturalWidth && r.width ? img.naturalWidth / r.width : 2;
      Z.s = clamp(natural, 1.8, 2.8);
      var dx = cx - (r.left + r.width / 2), dy = cy - (r.top + r.height / 2);
      Z.x = -dx * (Z.s - 1); Z.y = -dy * (Z.s - 1); Z.on = true;
      stage.classList.add('is-zoomed');
      clampZ(true);
    }
    function unzoom(instant) {
      if (!Z.on) return;
      Z.on = false; Z.s = 1; Z.x = Z.y = 0;
      stage.classList.remove('is-zoomed', 'is-panning');
      if (instant) { img.style.transition = 'none'; apply(); void img.offsetWidth; img.style.transition = ''; } else apply();
    }
    function down(e) {
      if (e.target.closest('button')) return;
      drag = { x: e.clientX, y: e.clientY, zx: Z.x, zy: Z.y, t: Date.now(), moved: false, touch: e.pointerType !== 'mouse' };
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    }
    function move(e) {
      if (drag) {
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) drag.moved = true;
        if (Z.on) {
          stage.classList.add('is-dragging');
          Z.x = drag.zx + dx; Z.y = drag.zy + dy; clampZ(true);
        } else if (drag.moved && drag.touch) {
          img.style.transition = 'none';
          img.style.transform = 'translate3d(calc(-50% + ' + (dx * 0.6).toFixed(1) + 'px), -50%, 0)';
        }
        return;
      }
      if (Z.on && e.pointerType === 'mouse') {
        // look around by moving the mouse
        var r = stage.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        Z.x = (0.5 - px) * 2 * Z.mx; Z.y = (0.5 - py) * 2 * Z.my;
        stage.classList.add('is-panning'); apply();
      }
    }
    function up(e) {
      if (!drag) return;
      var d = drag; drag = null;
      stage.classList.remove('is-dragging');
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!Z.on && d.moved && d.touch) {
        img.style.transition = '';
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && ((dx < 0 && i < items.length - 1) || (dx > 0 && i > 0))) { go(dx < 0 ? 1 : -1); }
        else img.style.transform = '';
        return;
      }
      if (!d.moved) { if (Z.on) unzoom(); else zoomAt(e.clientX, e.clientY); }
    }

    function trap(e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); if (Z.on) unzoom(); else close(); return; }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
      if (e.key === 'Tab') {
        var f = $$('button:not([hidden]):not([disabled])', v).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    }

    return { open: openSet, close: close, isOpen: function () { return open; } };
  })();

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !Viewer.isOpen() && basket && !basket.hidden) closeBasket();
  });

  // anything marked data-xeu-open opens its set in the viewer
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-xeu-open]');
    if (!t || !root.contains(t)) return;
    e.preventDefault();
    Viewer.open(t.getAttribute('data-xeu-open'), parseInt(t.getAttribute('data-xeu-index') || '0', 10) || 0, t);
  });

  /* the piano books page: the small pictures change the big one */
  (function pdpStage() {
    var st = $('[data-xeu-stage]', root); if (!st) return;
    var big = $('img', st);
    $$('[data-xeu-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(b.getAttribute('data-xeu-thumb'), 10) || 0;
        var it = (SETS.gallery || [])[n]; if (!it || !big) return;
        $$('[data-xeu-thumb]', root).forEach(function (x) { x.classList.toggle('is-current', x === b); });
        st.setAttribute('data-xeu-index', String(n));
        if (REDUCED) { big.src = it.mid || it.src; big.alt = it.alt || ''; return; }
        big.classList.add('is-out');
        setTimeout(function () {
          var pre = new Image();
          pre.onload = pre.onerror = function () { big.src = pre.src; big.alt = it.alt || ''; big.classList.toggle('is-cover', !!it.cover); big.classList.remove('is-out'); };
          pre.src = it.mid || it.src;
        }, 220);
      });
    });
  })();

  /* ── 5 · light ───────────────────────────────────────────────────────────── */
  if (REDUCED) return;
  if (!html.classList.contains('xeu-motion')) html.classList.add('xeu-motion');

  // things arrive as you reach them
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 }) : null;
  $$('[data-xeu-reveal]', root).forEach(function (el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); });

  // the wallpaper windows come on one after another
  var packs = $('.xeu-packs', root);
  if (packs) {
    var lightPacks = function () { $$('.xeu-pack', packs).forEach(function (p, n) { p.style.setProperty('--d', (n * 0.38).toFixed(2) + 's'); p.classList.add('is-lit'); }); };
    if ('IntersectionObserver' in window) {
      var packIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { lightPacks(); packIO.disconnect(); } }); }, { threshold: 0.2 });
      packIO.observe(packs);
    } else lightPacks();
  }

  // the hero: each girl in her own light, the camera breathing
  var hero = $('[data-xeu-hero]', root), pic = hero && $('[data-xeu-hero-pic]', hero), heroImg = pic && $('img', pic);
  if (!hero || !pic || !heroImg) return;
  if (!hero.classList.contains('is-lit')) {
    if (heroImg.complete && heroImg.naturalWidth) hero.classList.add('is-lit');
    else { heroImg.addEventListener('load', function () { hero.classList.add('is-lit'); }); setTimeout(function () { hero.classList.add('is-lit'); }, 2600); }
  }
  function mk(cls, inner) { var s = doc.createElement('span'); s.className = 'xeu-light ' + cls; s.setAttribute('aria-hidden', 'true'); if (inner) s.appendChild(doc.createElement('i')); pic.appendChild(s); return s; }
  var L = { drift: mk('xeu-light--drift'), sun: mk('xeu-light--sun'), shade: mk('xeu-light--shade'), dusk: mk('xeu-light--dusk', true), neon: mk('xeu-light--neon') };
  var duskBand = L.dusk.firstChild;
  var IW = 1920, IH = 1080;
  function boxPic() {
    var r = hero.getBoundingClientRect();
    var pos = (getComputedStyle(heroImg).objectPosition || '50% 28%').split(' ');
    var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || '50') / 100;
    if (isNaN(px)) px = 0.5; if (isNaN(py)) py = 0.28;
    var s = Math.max(r.width / IW, r.height / IH), w = IW * s, h = IH * s;
    pic.style.inset = 'auto';
    pic.style.left = ((r.width - w) * px).toFixed(1) + 'px'; pic.style.top = ((r.height - h) * py).toFixed(1) + 'px';
    pic.style.width = w.toFixed(1) + 'px'; pic.style.height = h.toFixed(1) + 'px';
    pic.classList.add('is-boxed');
  }
  boxPic();
  if ('ResizeObserver' in window) new ResizeObserver(boxPic).observe(hero); else addEventListener('resize', boxPic);

  var wave = function (t, a) { var v = 0; for (var k = 0; k < a.length; k++) v += a[k][0] * Math.sin(t * a[k][1] + a[k][2]); return v; };
  var rnd = function (a, b) { return a + Math.random() * (b - a); };
  var st = { vis: true, lx: 0, ly: 0, pass: null, nextPass: rnd(2.2, 4), flick: null, nextFlick: rnd(2.5, 6) };
  var ptr = { x: 0, y: 0, t: -1e9 };
  if (FINE) addEventListener('pointermove', function (e) { ptr.x = e.clientX; ptr.y = e.clientY; ptr.t = performance.now(); }, { passive: true });
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { st.vis = e.isIntersecting; if (st.vis) loop(); }); }).observe(hero);
  doc.addEventListener('visibilitychange', function () { if (!doc.hidden) loop(); });

  var T0 = performance.now(), raf = 0;
  function frame(now) {
    raf = 0;
    if (!st.vis || doc.hidden) return;
    var t = (now - T0) / 1000;
    // the light and the camera come up over the first 2.4 s, from exactly where the page stands, so nothing jumps when this arrives
    var k = t >= 2.4 ? 1 : (t / 2.4) * (t / 2.4) * (3 - 2 * (t / 2.4));
    // the camera breathes the way a held camera does, and turns a little toward the pointer
    var br = Math.sin(t * 2 * Math.PI / 7.2);
    var cx = wave(t, [[0.22, 0.17, 1.0], [0.07, 0.61, 0.3]]), cy = 0.16 * Math.sin(t * 2 * Math.PI / 7.2 + 0.7);
    var r = hero.getBoundingClientRect();
    var inside = FINE && now - ptr.t < 4000 && ptr.y >= r.top && ptr.y <= r.bottom;
    var nx = inside ? clamp((ptr.x - r.left) / r.width * 2 - 1, -1, 1) : 0, ny = inside ? clamp((ptr.y - r.top) / r.height * 2 - 1, -1, 1) : 0;
    st.lx += (nx - st.lx) * 0.035; st.ly += (ny - st.ly) * 0.035;
    pic.style.transform = 'translate3d(' + ((cx - st.lx * 0.7) * k).toFixed(3) + '%, ' + ((cy - st.ly * 0.5) * k).toFixed(3) + '%, 0) scale(' + (1.045 + 0.007 * br * k).toFixed(4) + ')';
    // xeris: the sun comes and goes behind slow cloud
    var cloud = clamp(0.5 + 0.5 * wave(t, [[0.6, 0.11, 0.4], [0.3, 0.27, 1.7], [0.1, 0.71, 0.2]]), 0, 1);
    L.sun.style.opacity = ((0.22 + 0.5 * cloud) * k).toFixed(3);
    L.shade.style.transform = 'translate3d(' + (70 * Math.sin(t * 2 * Math.PI / 96)).toFixed(2) + '%, 0, 0)';
    L.shade.style.opacity = (0.4 * (1 - cloud) * k).toFixed(3);
    // the sky drifts over all three, very slowly
    L.drift.style.transform = 'translate3d(' + (28 * Math.sin(t * 2 * Math.PI / 150 + 1.2)).toFixed(2) + '%, ' + (3 * Math.sin(t * 2 * Math.PI / 61)).toFixed(2) + '%, 0)';
    L.drift.style.opacity = (0.16 * k).toFixed(3);
    // xeu: the last of the dusk light passes over her now and then
    if (!st.pass && t > st.nextPass) st.pass = { t0: t, dur: rnd(2.6, 4.2), k: rnd(0.55, 0.95) };
    if (st.pass) {
      var u = (t - st.pass.t0) / st.pass.dur;
      if (u >= 1) { st.pass = null; st.nextPass = t + rnd(3, 8); L.dusk.style.opacity = '0'; }
      else { duskBand.style.transform = 'translate3d(' + (48 - 96 * u).toFixed(2) + '%, 0, 0)'; L.dusk.style.opacity = (Math.sin(Math.PI * u) * st.pass.k * k).toFixed(3); }
    }
    // kuro: a red sign somewhere off to her side hums, and now and then catches
    var o = 0.3 + 0.035 * Math.sin(t * 7.3) * Math.sin(t * 1.1);
    if (!st.flick && t > st.nextFlick) {
      var n = Math.random() < 0.5 ? 2 : 3, seq = [], at = 0;
      for (var k = 0; k < n; k++) { var dur = rnd(0.04, 0.09); seq.push([at, at + dur, rnd(0.06, 0.16)]); at += dur + rnd(0.05, 0.14); }
      st.flick = { t0: t, seq: seq, end: at };
    }
    if (st.flick) {
      var kk = t - st.flick.t0;
      if (kk > st.flick.end) { st.flick = null; st.nextFlick = t + rnd(3.5, 9); }
      else for (var q = 0; q < st.flick.seq.length; q++) { var f = st.flick.seq[q]; if (kk >= f[0] && kk < f[1]) o = f[2]; }
    }
    L.neon.style.opacity = (o * k).toFixed(3);
    raf = requestAnimationFrame(frame);
  }
  function loop() { if (!raf && st.vis && !doc.hidden) raf = requestAnimationFrame(frame); }
  loop();
})();
